import superagentPromisePlugin from 'superagent-promise-plugin'

import http_agent from './http_agent'
import config from 'config'

function _genericCatch() {
	return {
		error_code: -1,
		payload: {
			message: 'Something went wrong. Please try again later.',
		},
	}
}

function searchSchools(search, countryId, stateId, filterMasterSchools, checkRolePermission) {
	return http_agent.post(config.services + 'school/search')
		.send({
			search,
			state: stateId,
			country: countryId,
			filterMasterSchools,
			split: 1,
			checkRolePermission,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			response = JSON.parse(response.text)
			return response
		})
		.catch(err => {
			_genericCatch(err)
		})
}

export default {
	searchSchools,
}
